<script lang="ts" setup>
import {reset} from "@formkit/core";

definePageMeta({
  layout: 'guest'
  // auth: {
  //   roles: [UserRoleEnum.ADMIN, UserRoleEnum.DEALER]
  // }
})

const {t} = useI18n({
  useScope: 'global'
})


const filters = ref({
  currentVin: '',
  vinCode: [],
});

const activeFilters = ref<typeof filters | null>(filters.value);
const carsFilter = computed(() => {
  return {
    ...activeFilters.value,
  }
});

const {
  next, prev, data,
  filters: fetchFilters,
  total,
  isLoading,
  currentPage,
  currentPageSize,
  pageCount,
  isFirstPage,
  isLastPage,
} = await useGuestCars();


watch(carsFilter, (val) => {
  fetchFilters.value = val;
});
onMounted(() => {
  setTimeout(() => {
    //TODO: remove this timeout... temp fix
    fetchFilters.value = filters.value;
  }, 1000)
})

const submitHandler = async (formData) => {
  if (formData.currentVin){
    formData.vinCode.push(formData.currentVin);
    formData.currentVin = '';
  }
  filters.value = formData
  activeFilters.value = formData

  await new Promise((r) => setTimeout(r, 1000));
};
const onFilterReset = async () => {
  reset("guest-cars-filter");
  activeFilters.value = filters.value
};

const onRemoveClick = (node) => {
  console.log('onRemoveClick', node)
  node.input(filters.value.vinCode.filter((_, i) => i !== node.index));
}

</script>

<template>
  <LayoutPageWithSidebar :sidebar-title="t('cars.filters.title')">
    <template #after-wrapper>
      <ConsoleLog>
        {{ data }}
      </ConsoleLog>
    </template>
    <template #default>
      <LayoutPageWithSidebarListHeader
        :title="t('cars.labels.title')"
        :total="total"
      />
      <PageCarsGuestList :cars="data" />
      <AppPagination
        :is-loading="isLoading"
        :current-page="currentPage"
        :page-count="pageCount"
        :current-page-size="currentPageSize"
        :is-first-page="isFirstPage"
        :is-last-page="isLastPage"
        @next="next"
        @prev="prev"
        @page-click="currentPage = $event"
      />
    </template>
    <template #sidebar>
      <FormKit
        id="guest-cars-filter"
        v-slot="{state,value}"
        v-model="filters"
        name="guest-cars-filter"
        type="form"
        :actions="false"
        use-local-storage
        @submit="submitHandler"
      >
        <FormKit
          v-slot="{ items, node, value }"
          type="list"
          name="vinCode"
          dynamic
        >
          <FormKit
            v-for="(item, index) in items"
            :key="item"
            :index="index"
            :readonly="true"
            type="text"
            :placeholder="t('cars.filters.vinCode')"
            suffix-icon="close"
            @suffix-icon-click="onRemoveClick(node)"
          />
        </FormKit>


        <FormKit
          type="text"
          name="currentVin"
          :placeholder="t('cars.filters.vinCode')"
        />

        <FormKit
          type="submit"
          variant="outline"
          :label="t('cars.filters.show')"
        />

        <FormKit
          v-if="state.dirty"
          type="action"
          variant="link"
          prefix-icon="reset"
          :label="t('cars.filters.reset')"
          @click.prevent="onFilterReset"
        />
      </FormKit>
    </template>
  </LayoutPageWithSidebar>
</template>

<style lang="scss" scoped>

.item-label2 {
  display: block;
  font-size: 12px;
  margin-bottom: 8px;
}
</style>
